import { Typography } from '@/components'
import { ErrorContainer } from './styles'
import { useTranslation } from 'react-i18next'
import { AlertCircleIcon } from 'lucide-react'

const ClaimsPageError = () => {
  const { t } = useTranslation()

  return (
    <ErrorContainer>
      <AlertCircleIcon />
      <Typography variant="h5">{t('claimsPage.error')}</Typography>
    </ErrorContainer>
  )
}

export default ClaimsPageError
